module.exports = function basicAuth(credentials) {
    const crypto = require('crypto');
    return (req, res, next) => {
        const b64auth = (req.headers.authorization || '').split(' ')[1] || '';
        const [login, password] = Buffer.from(b64auth, 'base64').toString().split(':');
        const reqPass = Buffer.from(password || '');
        const expectedPass = Buffer.from(credentials[login] || '');
        if (
            login &&
            password &&
            credentials[login] &&
            reqPass.length === expectedPass.length &&
            crypto.timingSafeEqual(reqPass, expectedPass)
        ) {
            req.user = { username: login };
            return next();
        }
        res.writeHead(401, { 'WWW-Authenticate': 'Basic realm="Protected"' });
        res.end('Authentication required.');
    };
};
